<template>
  <o-form ref="form"
          :title="$t('medtastic.workshop')"
          :url="'/api/medtastic/workshops/' + $route.params.id + '?include=sponsors.sponsor.sponsor_checkboxes,sponsor_checkboxes,registrations.checkboxes'"
          class="ortic-form-horizontal">
    <template slot-scope="props">
      <b-row>
        <b-col>
          <o-input v-model="props.item.title" :errorField="'title'" :label="$t('medtastic.workshop_title')"/>
          <o-input v-model="props.item.region" :label="$t('medtastic.region')"/>
          <o-form-group :label="$t('medtastic.location')">
            <div class="input-group">
              <SummernoteEditor v-model="props.item.location" class="w-100"/>
            </div>
          </o-form-group>
          <o-value-select v-model="props.item.language" :errorField="'language'" :items="workshop_locale"
                          :label="$t('core.language')"/>
          <o-file-upload v-model="props.item.picture" :label="$t('medtastic.picture')" accept="image/*" class="d-none"/>
          <o-file-upload v-model="props.item.pdf_document" :label="$t('medtastic.document')" accept="application/pdf" class="d-none"/>
          <o-input v-model="props.item.speaker" :label="$t('medtastic.speaker')"  class="d-none"/>
          <o-file-upload v-model="props.item.speaker_signature" :label="$t('medtastic.speaker_signature')"
                         accept="image/*"  class="d-none"/>
          <o-checkbox v-model="props.item.signup_active" :label="$t('medtastic.signup_active')"></o-checkbox>
          <o-form-group :label="$t('medtastic.signup_hint')">
            <div class="input-group">
              <SummernoteEditor v-model="props.item.signup_hint" class="w-100"/>
              <!-- <o-vue-editor v-model="props.item.signup_hint" class="w-100"/> -->
            </div>
          </o-form-group>
          <o-datepicker v-model="props.item.date" :errorField="'date'" :label="$t('core.date')" :typeable="false"/>
          <o-timepicker v-model="props.item.time" :errorField="'time'" :label="$t('medtastic.time')"/>
          <o-timepicker v-model="props.item.end_time" :errorField="'end_time'" :label="$t('medtastic.end_time')"/>
          <o-checkbox :label="$t('medtastic.with_apero')" v-model="props.item.with_apero"></o-checkbox>
          <o-form-group :label="$t('medtastic.agenda')">
            <div class="input-group">
              <SummernoteEditor v-model="props.item.agenda" class="w-100"/>
            </div>
          </o-form-group>
          <o-checkbox :label="$t('medtastic.private')" v-model="props.item.private"></o-checkbox>
          <o-checkbox :label="$t('medtastic.show_lundbeck_confirmation')" v-model="props.item.show_lundbeck_confirmation" class="d-none"></o-checkbox>
        </b-col>
        <b-col>
          <o-form-group :label="$t('core.description')">
            <div class="input-group">
              <SummernoteEditor v-model="props.item.description" class="w-100"/>
            </div>
          </o-form-group>
          <o-form-group :label="$t('medtastic.email_comment')" class="d-none">
            <div class="input-group">
              <SummernoteEditor v-model="props.item.email_comment" class="w-100"/>
            </div>
          </o-form-group>
          <o-input v-model="props.item.credits" :errorField="'credits'" :label="$t('medtastic.credits')"/>
          <b-button v-b-toggle.collapse-speaker class="w-100 mb-3" variant="light">
            <span class="when-open"><fa icon="chevron-up"/></span>
            <span class="when-closed"><fa icon="chevron-down"/></span>
            {{ $t('medtastic.speakers') }}
          </b-button>
          <b-collapse id="collapse-speaker" class="mt-2">
            <o-input v-model="props.item.speaker_1" :label="$t('medtastic.speaker_1')"/>
            <o-file-upload v-model="props.item.speaker_1_pic" :label="$t('medtastic.speaker_1_pic')" accept="image/*"/>
            <o-input v-model="props.item.speaker_1_institution" :label="$t('medtastic.speaker_1_institution')"/>
            <o-input v-model="props.item.speaker_2" :label="$t('medtastic.speaker_2')"/>
            <o-file-upload v-model="props.item.speaker_2_pic" :label="$t('medtastic.speaker_2_pic')" accept="image/*"/>
            <o-input v-model="props.item.speaker_2_institution" :label="$t('medtastic.speaker_2_institution')"/>
            <o-input v-model="props.item.speaker_3" :label="$t('medtastic.speaker_3')"/>
            <o-file-upload v-model="props.item.speaker_3_pic" :label="$t('medtastic.speaker_3_pic')" accept="image/*"/>
            <o-input v-model="props.item.speaker_3_institution" :label="$t('medtastic.speaker_3_institution')"/>
            <o-input v-model="props.item.speaker_4" :label="$t('medtastic.speaker_4')"/>
            <o-file-upload v-model="props.item.speaker_4_pic" :label="$t('medtastic.speaker_4_pic')" accept="image/*"/>
            <o-input v-model="props.item.speaker_4_institution" :label="$t('medtastic.speaker_4_institution')"/>
            <o-input v-model="props.item.speaker_5" :label="$t('medtastic.speaker_5')"/>
            <o-file-upload v-model="props.item.speaker_5_pic" :label="$t('medtastic.speaker_5_pic')" accept="image/*"/>
            <o-input v-model="props.item.speaker_5_institution" :label="$t('medtastic.speaker_5_institution')"/>
          </b-collapse>

          <b-button v-b-toggle.collapse-contact class="w-100 mb-3" variant="light">
            <span class="when-open"><fa icon="chevron-up"/></span>
            <span class="when-closed"><fa icon="chevron-down"/></span>
            {{ $t('medtastic.contacts') }}
          </b-button>
          <b-collapse id="collapse-contact" class="mt-2">
            <o-form-group :label="$t('medtastic.contact_1')">
              <div class="input-group">
                <SummernoteEditor v-model="props.item.contact_1" class="w-100"/>
                <!-- <o-vue-editor v-model="props.item.contact_1" class="w-100"/> -->
              </div>
            </o-form-group>
            <o-file-upload v-model="props.item.contact_1_pic" :label="$t('medtastic.contact_1_pic')" accept="image/*"/>
            <o-form-group :label="$t('medtastic.contact_2')">
              <div class="input-group">
                <SummernoteEditor v-model="props.item.contact_2" class="w-100"/>
                <!-- <o-vue-editor v-model="props.item.contact_2" class="w-100"/> -->
              </div>
            </o-form-group>
            <o-file-upload v-model="props.item.contact_2_pic" :label="$t('medtastic.contact_2_pic')" accept="image/*"/>
            <o-form-group :label="$t('medtastic.contact_3')">
              <div class="input-group">
                <SummernoteEditor v-model="props.item.contact_3" class="w-100"/>
                <!-- <o-vue-editor v-model="props.item.contact_3" class="w-100"/> -->
              </div>
            </o-form-group>
            <o-file-upload v-model="props.item.contact_3_pic" :label="$t('medtastic.contact_3_pic')" accept="image/*"/>
            <o-form-group :label="$t('medtastic.contact_4')">
              <div class="input-group">
                <!-- <o-vue-editor v-model="props.item.contact_4" class="w-100"/> -->
                <SummernoteEditor v-model="props.item.contact_4" class="w-100"/>
              </div>
            </o-form-group>
            <o-file-upload v-model="props.item.contact_4_pic" :label="$t('medtastic.contact_4_pic')" accept="image/*"/>
            <o-form-group :label="$t('medtastic.contact_5')">
              <div class="input-group">
                <SummernoteEditor v-model="props.item.contact_5" class="w-100"/>
                <!-- <o-vue-editor v-model="props.item.contact_5" class="w-100"/> -->
              </div>
            </o-form-group>
            <o-file-upload v-model="props.item.contact_5_pic" :label="$t('medtastic.contact_5_pic')" accept="image/*"/>
          </b-collapse>
        </b-col>
      </b-row>
    </template>
    <template slot="child" slot-scope="props">
      <b-tabs>
        <b-tab :title="$t('medtastic.sponsors')" active>
          <o-card>
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th>{{ $t('medtastic.sponsor') }}</th>
                  <th class="text-right">
                    <b-btn variant="primary" @click.prevent="openSponsor()">
                      <fa icon="plus"/>
                    </b-btn>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(sponsor, i) in props.item.sponsors">
                  <td>{{ sponsor.sponsor.name }}</td>
                  <td class="text-right text-nowrap">
                    <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                      <b-btn variant="secondary" @click.prevent="props.item.sponsors.splice(i, 1)">
                        <fa icon="times"/>
                      </b-btn>
                      <b-btn variant="primary" @click.prevent="openSponsor(i)">
                        <fa icon="pencil-alt"/>
                      </b-btn>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </o-card>
        </b-tab>
        <b-tab :title="$t('medtastic.registrations')">
          <o-card>
            <div class="table-responsive">
              <b-btn variant="primary" @click.prevent="xlsx()">
                <fa icon="file-excel"/>
                {{ $t('medtastic.export') }}
              </b-btn>
              <table class="table">
                <thead>
                <tr>
                  <th>{{ $t('core.title') }}</th>
                  <th>{{ $t('core.first_name') }}</th>
                  <th>{{ $t('core.last_name') }}</th>
                  <th>{{ $t('core.email') }}</th>
                  <th>{{ $t('medtastic.institution') }}</th>
                  <th>{{ $t('medtastic.institution_address') }}</th>
                  <th>{{ $t('core.country') }}</th>
                  <th>{{ $t('core.language') }}</th>
                  <th>{{ $t('medtastic.certificate') }}</th>
                  <th>{{ $t('medtastic.notification') }}</th>
                  <th class="text-right">
                    <b-btn variant="primary" @click.prevent="open()">
                      <fa icon="plus"/>
                    </b-btn>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(registration, i) in props.item.registrations">
                  <td>{{ registration.title }}</td>
                  <td>{{ registration.first_name }}</td>
                  <td>{{ registration.last_name }}</td>
                  <td>{{ registration.email }}</td>
                  <td>{{ registration.institution }}</td>
                  <td>{{ registration.institution_address }}, {{ registration.city }}, {{ registration.postal_code }}
                  </td>
                  <td>{{ registration.country ? $t('medtastic.' + registration.country) : '' }}</td>
                  <td>{{ workshop_locale[registration.language] }}</td>
                  <td class="text-nowrap text-center">
                    <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                      <o-button v-if="registration.id" type="button" variant="primary"
                                @click.prevent="certificate(i)">
                        <fa icon="file-pdf"/>
                      </o-button>
                    </div>
                  </td>
                  <td class="text-nowrap text-center">
                    <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                      <o-button v-if="registration.id" :loading="sending.includes(i + 'confirmation')"
                                :title="$t('medtastic.confirmation_btn_tooltip_text')"
                                type="button"
                                variant="secondary" @click.prevent="sendEmail(i)">
                        <fa icon="user-check"/>
                      </o-button>
                      <o-button v-if="registration.id" :loading="sending.includes(i + 'reminder')"
                                :title="$t('medtastic.reminder_btn_tooltip_text')"
                                type="button"
                                variant="primary"
                                @click.prevent="sendEmail(i, 'reminder')">
                        <fa icon="calendar-alt"/>
                      </o-button>
                    </div>
                  </td>
                  <td class="text-right text-nowrap">
                    <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                      <b-btn variant="secondary" @click.prevent="props.item.registrations.splice(i, 1)">
                        <fa icon="times"/>
                      </b-btn>
                      <b-btn variant="primary" @click.prevent="open(i)">
                        <fa icon="pencil-alt"/>
                      </b-btn>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </o-card>
        </b-tab>
      </b-tabs>
      <b-modal id="modal-add-edit" ref="addEditModal" :ok-title="$t('core.save')" :title="$t('medtastic.registration')"
               size="lg" @ok="ok">
        <b-row>
          <b-col>
            <o-input v-model="formSchema.title" :label="$t('core.title')"></o-input>
            <o-input v-model="formSchema.first_name" :label="$t('core.first_name') + '*'"></o-input>
            <o-input v-model="formSchema.last_name" :label="$t('core.last_name') + '*'"></o-input>
            <o-input v-model="formSchema.email" :label="$t('core.email') + '*'"></o-input>
            <span class="text-muted mb-2">{{ $t('medtastic.participant_email_hint_text') }}</span>
            <div class="form-group mt-3">
              <label>{{ $t('medtastic.newsletter_subscription', {eventTitle: props.item.title}) }}</label>
              <b-form-radio v-model="formSchema.newsletter_subscription" name="newletter_subscription" value="yes">
                {{ $t('core.yes') }}
              </b-form-radio>
              <b-form-radio v-model="formSchema.newsletter_subscription" name="newletter_subscription" value="no">
                {{ $t('core.no') }}
              </b-form-radio>
            </div>
            <div class="form-group mt-3">
              <label>{{ $t('medtastic.salmon_pharma') }}</label>
              <b-form-checkbox v-model="formSchema.salmon_pharma" name="salmon_pharma" value="yes" unchecked-value="no">
                <span v-html="$t('medtastic.salmon_pharma_text')"></span>
              </b-form-checkbox>
            </div>
          </b-col>
          <b-col>
            <o-input v-model="formSchema.institution" :label="$t('medtastic.institution')"></o-input>
            <o-input v-model="formSchema.institution_address"
                     :label="$t('medtastic.institution_address') + '*'"></o-input>
            <o-input v-model="formSchema.city" :label="$t('medtastic.city') + '*'"></o-input>
            <o-input v-model="formSchema.postal_code" :label="$t('medtastic.postal_code') + '*'" type="number"></o-input>
            <o-value-select ref="countrySelector" v-model="formSchema.country" :items="countries"
                            :label="$t('core.country') + '*'"
                            class="mt-3">
            </o-value-select>
            <o-value-select ref="langSelector" v-model="formSchema.language" :items="workshop_locale"
                            :label="$t('core.language') + '*'"
                            class="mt-3">
            </o-value-select>
            <o-value-select ref="userTypeSelector" v-model="formSchema.user_type" :items="userTypes"
                            :label="$t('medtastic.user_type') + '*'"
                            class="mt-3">
            </o-value-select>
            <o-input v-if="formSchema.user_type === 'Other'" v-model="formSchema.user_type_other"
                     :label="$t('medtastic.user_type_other') + '*'"></o-input>

          </b-col>
        </b-row>
      </b-modal>
      <b-modal id="modal-add-edit-sponsor" ref="addEditModalSponsor" :ok-title="$t('core.save')"
               :title="$t('medtastic.sponsors')" size="lg" @ok="okSponsor">
        <b-row>
          <b-col>
            <o-value-select ref="sponsorSelector" v-model="formSponsor.sponsor_id" url="/api/medtastic/sponsors"
                            value-field="id" text-field="name" :label="$t('medtastic.sponsor')"
                            class="mt-3">
            </o-value-select>
            <div class="form-group mt-3">
              <template v-if="sponsor && sponsor.sponsor_checkboxes && sponsor.sponsor_checkboxes.data && Object.keys(sponsor.sponsor_checkboxes.data).length">
                <div class="text-muted mb-2">{{ $t('medtastic.workshop_sponsor_checkbox_hint_text') }}</div>
                <template v-for="checkbox in sponsor.sponsor_checkboxes.data">
                  <div class="form-group">
                    <div class="col-md-12 pl-0 pr-0">
                      <b-form-checkbox v-model="props.item.sponsor_checkbox_array"
                                       :name="sponsor.name + '_' + checkbox.id"
                                       :value="checkbox.id" class="long-checkbox">
                        <span v-html="checkbox['label_' + locale]"/>
                      </b-form-checkbox>
                    </div>
                  </div>
                </template>
              </template>
            </div>
          </b-col>
        </b-row>
      </b-modal>
    </template>
  </o-form>
</template>

<script>
import axios from 'axios'
// import wysiwyg from 'vue-wysiwyg'
// import 'vue-wysiwyg/dist/vueWysiwyg.css'
import Vue from 'vue'
import {mapGetters} from "vuex"

// Vue.use(wysiwyg, { hideModules: { 'image': true } })

export default {
  data: () => ({
    workshop_locale: window.config.workshop_locale,
    i: null,
    formSchema: {},
    sending: [],
    countries: [],
    userTypes: [],
    formSponsor: {},
    sponsor: [],
  }),

  created () {
    this.countries = [
      { value: 'switzerland', text: this.$i18n.t('medtastic.switzerland') },
      { value: 'germany', text: this.$i18n.t('medtastic.germany') },
      { value: 'austria', text: this.$i18n.t('medtastic.austria') }
    ]
    this.userTypes = [
      { value: '', text: this.$i18n.t('core.select') },
      { value: 'Adult_Psychiatrists', text: this.$i18n.t('medtastic.adult_psychiatrists') },
      {
        value: 'Child_And_Adolescent_Psychiatrists',
        text: this.$i18n.t('medtastic.child_and_adolescent_psychiatrists')
      },
      { value: 'Pediatricians', text: this.$i18n.t('medtastic.pediatricians') },
      { value: 'General_Practitioners', text: this.$i18n.t('medtastic.general_practitioners') },
      { value: 'Other', text: this.$i18n.t('medtastic.other_specify') }
    ]
  },
  computed: mapGetters({
    locale: 'lang/locale'
  }),
  methods: {
    open (i = null) {
      this.reset()
      this.i = i
      if (this.i !== null) {
        this.formSchema = Object.assign({}, this.formSchema, this.$refs.form.item.registrations[this.i])
      }
      this.$refs.addEditModal.show()
    },
    ok () {
      if (this.i !== null) {
        this.$set(this.$refs.form.item.registrations, [this.i], this.formSchema)
      } else {
        const lenght = this.$refs.form.item.registrations.length
        delete this.formSchema.id
        this.$set(this.$refs.form.item.registrations, [lenght], this.formSchema)
      }
      this.$refs.addEditModal.hide()
    },
    reset () {
      this.formSchema = Object.assign({}, this.formSchema, {
        title: null,
        first_name: null,
        last_name: null,
        institution: null,
        institution_address: null,
        country: null,
        city: null,
        postal_code: null,
        email: null,
        language: null,
        user_type: '',
        user_type_other: '',
        newsletter_subscription: 'yes'
      })
      this.i = null
    },
    sendEmail (i = null, type = 'confirmation') {
      if (i !== null) {
        this.sending.push(i + '' + type)
        axios.post('/api/medtastic/workshop_registrations/email', {
          'id': this.$refs.form.item.registrations[i].id,
          'type': type
        }).then((response) => {
          this.sending = []
        }).catch((error) => {
          this.sending = []
          console.log(error)
        })
      }
    },
    certificate (i = null) {
      if (i !== null) {
        let registration = this.$refs.form.item.registrations[i]
        axios.post('/api/medtastic/workshop_registrations/certificate', {
          'id': registration.id
        }, { responseType: 'arraybuffer' })
            .then((response) => {
              require('downloadjs')(response.data,
                  registration.first_name + '_' + registration.last_name + '.pdf', 'application/pdf'
              )
            }).catch((error) => {
          console.log(error)
        })
      }
    },
    xlsx () {
      var $self = this
      axios.post('/api/medtastic/workshop_registrations/export', {
        'id': $self.$refs.form.item.id
      }, { responseType: 'arraybuffer' })
          .then((response) => {
            require('downloadjs')(response.data,
                $self.$refs.form.item.title + ' ' + $self.$i18n.t('medtastic.registrations') + '.xlsx',
                'application/vnd.ms-excel'
            )
          }).catch((error) => {
        console.log(error)
      })
    },
    openSponsor (i = null) {
      this.resetSponsor()
      this.i = i
      if (this.i !== null) {
        this.formSponsor = Object.assign({}, this.formSponsor, this.$refs.form.item.sponsors[this.i])
      }
      this.$refs.addEditModalSponsor.show()
    },
    okSponsor () {
      let options = this.$refs.sponsorSelector.$el.querySelector('select').options
      this.formSponsor.sponsor.name = options.selectedIndex !== -1 ? options[options.selectedIndex].textContent : ''

      if (this.i !== null) {
        this.$set(this.$refs.form.item.sponsors, [this.i], this.formSponsor)
      } else {
        const length = this.$refs.form.item.sponsors.length
        delete this.formSponsor.id
        this.$set(this.$refs.form.item.sponsors, [length], this.formSponsor)
      }
      this.$refs.addEditModalSponsor.hide()
    },
    resetSponsor () {
      this.formSponsor = Object.assign({}, this.formSponsor, {
        workshop_id: this.$route.params.id,
        sponsor_id: null,
        sponsor: {},
        sponsor_checkbox_array: []
      })
      this.i = null
    },
    getSponsors: function (id) {
      axios.get('/api/medtastic/sponsors?include=sponsor_checkboxes&filter%5Bid%5D=' + id)
          .then((response) => {
            this.sponsor = response.data.data[0]
          })
          .catch((error) => {
            console.log(error)
          })
    },
  },
  watch: {
    'formSponsor.sponsor_id': function (newVal, oldVal) {
      this.getSponsors(newVal)
    }
  }
}
</script>

<style>
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

.editr table td {
  height: 40px !important;
}
</style>
